/**
 * @param {{ name_english?: string|null, name_portuguese?: string|null, name_spanish?: string|null }} amenity
 * @param {string} [language] i18n language code (en, pt, es)
 */
export function amenityDisplayName(amenity, language) {
    if (!amenity) return ''
    const lng = language || 'en'
    if (lng === 'pt') return amenity.name_portuguese || amenity.name_english || amenity.name_spanish || ''
    if (lng === 'es') return amenity.name_spanish || amenity.name_english || amenity.name_portuguese || ''
    return amenity.name_english || amenity.name_portuguese || amenity.name_spanish || ''
}
